import { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import LanguageOption from '../../components/LanguageOption'
import { Locale } from '../../components/Locale'
import { useGet } from '../../hooks/useGet'
import { useToken } from '../../hooks/useToken'
import {
  getTopUpPackages,
  GetTopUpPackagesOutput,
  topUpCredit,
} from '../../sdk/credit'
import './Top_up.css'
import { useEffect } from 'react'
import { usePageLayout } from '../../hooks/usePageLayout'

export default function TopUp() {
  // FIXME: replace localhost with actual domain

  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: {
        en: 'Top Up Credits',
        zh_cn: '充值点数',
        zh_hk: '充值點數',
      },
    }),
    [],
  )

  // TopUp page should show all navigation elements
  usePageLayout(layoutOptions)

  const { token } = useToken()
  const navigate = useNavigate()
  const [params] = useSearchParams()

  const package_id = +params.get('package')!

  useEffect(() => {
    if (package_id) {
      requestTopUp(package_id)
    }
  }, [package_id])

  async function requestTopUp(package_id: number) {
    if (!token) {
      navigate(
        `/login?` +
          new URLSearchParams({
            page: `top-up`,
            package: package_id.toString(),
          }).toString(),
      )
      return
    }
    let json = await topUpCredit({
      body: {
        package_id,
      },
    })

    // redirect to the payment page
    window.location.href = json.url
  }

  const topUpPackages = useGet({ packages: [] }, () => getTopUpPackages({}))

  return (
    <div className="Top_up">
      <h2>
        <Locale
          en="Choose Your Package"
          zh_cn="选择您的套餐"
          zh_hk="選擇您的套餐"
        />
      </h2>
      <div className="top-up-container"></div>
      {topUpPackages.state.packages?.map(topUpPackage => {
        let unitPrice = (topUpPackage.fee / topUpPackage.credits).toFixed(2)
        return (
          <div
            key={topUpPackage.package_id}
            className="top-up-option"
            onClick={() => requestTopUp(topUpPackage.package_id)}
          >
            <h3 className="top-up-option-title">
              <Locale
                en={topUpPackage.title_en}
                zh_cn={topUpPackage.title_zh_cn}
                zh_hk={topUpPackage.title_zh_hk}
              />
            </h3>
            <div className="top-up-option-description">
              <div>
                <Locale
                  en={`${topUpPackage.fee} for ${topUpPackage.credits} credits`}
                  zh_cn={`${topUpPackage.fee} 元充值 ${topUpPackage.credits} 点数`}
                  zh_hk={`${topUpPackage.fee} 元充值 ${topUpPackage.credits} 點數`}
                />
              </div>
              <div>
                (
                <Locale
                  en={`${unitPrice} per credit`}
                  zh_cn={`${unitPrice} 元/点`}
                  zh_hk={`${unitPrice} 元/點`}
                />
                )
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
